/**
 * Announcement Bar Auto-Scroll
 * Automatically rotates through announcements every few seconds
 * Loops back to first when reaching the end
 */

(function() {
  'use strict';

  function initAnnouncementAutoScroll() {
    const nextButton = document.querySelector('.announcement-bar__content-nav--right');
    const prevButton = document.querySelector('.announcement-bar__content-nav--left');
    
    if (!nextButton || !prevButton) {
      setTimeout(initAnnouncementAutoScroll, 500);
      return;
    }

    // Interval in milliseconds (3000 = 3 seconds)
    const interval = 3000;

    setInterval(function() {
      // Check if next button is disabled (reached the end)
      if (nextButton.classList.contains('announcement-bar__content-nav--disabled')) {
        // Go back to the first announcement by clicking prev until we're at the start
        while (!prevButton.classList.contains('announcement-bar__content-nav--disabled')) {
          prevButton.click();
        }
      } else {
        // Normal - go to next
        nextButton.click();
      }
    }, interval);

    console.log('Announcement bar auto-scroll initialized - rotating every ' + (interval / 1000) + ' seconds');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initAnnouncementAutoScroll, 1000);
    });
  } else {
    setTimeout(initAnnouncementAutoScroll, 1000);
  }

  window.addEventListener('shopify:section:load', function() {
    setTimeout(initAnnouncementAutoScroll, 1000);
  });

})();
